<template>
  <div>
  <!-- <div class="banner__container"> -->
    <transition-group name="appear" tag="div" class="banner__container">
      <div v-for="(info, iid) in infoItems" :key="`key-${iid}`" class="banner" :class="'banner--' + info.type" @click="removeItem(iid)">
        <div class="banner__text">{{info.msg}}</div>
        <!-- <div class="banner__close" @click="removeItem(iid)">{{iid}}</div> -->
        <img class="banner__close" src="../assets/times.svg" alt="remove item" @click="removeItem(iid)">
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  data(){
    return{
    }
  },
  computed:{
    infoItems(){
      return this.$store.getters.infoItems;
    }
  },
  methods: {
    removeItem(item_index){
      this.$store.dispatch('removeInfoItem', item_index);
    }
  }
}
</script>

<style scoped lang="scss">
  // .banner__container {
  //   width: 75vw;
  //   margin: 0 auto;
  // }

  .banner{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: .5rem auto;
    width: 75%;
    flex-direction: row;

    border-radius: .5rem;
    padding: .5rem;
    z-index: 10000;

    &__text{
      width: 85%;
    }

    &__close{
      height: 2rem;
    }

    &--error{
      // width: 100%;
      background-color: rgba($telenor-info-red, .95);
    }
    &--info{
      background-color: rgba($telenor-info-blue, .95);
    }
    &--success{
      background-color: rgba($telenor-info-green, .95);
    }
    &--warning{
      background-color: rgba($telenor-info-yellow, .95);
    }
  }


  .appear-enter-active, .appear-leave-active {
  transition: opacity .5s;
  }
  .appear-enter, .appear-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

</style>